// widgets/NotesSummary.jsx (uses /inventory/notes/summary?ids=... or individual notes)
import React, { useEffect, useState } from 'react';
import { api } from '../scripts/api';
import { MessageSquare } from 'lucide-react';
import '../App.css';
import './Widgets.css';

export default function NotesSummary({ inventoryIds = [] }) { // Pass IDs as prop if dynamic
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const ids = inventoryIds.join(',') || '1,2,3'; // Example or fetch from inventory list
        const { data } = await api.get('/inventory/notes/summary', { params: { ids } });
        setSummary(data.byId || {});
      } catch (e) {
        setError(e?.response?.data?.error || 'Failed to load notes summary');
      } finally {
        setLoading(false);
      }
    };
    fetchSummary();
  }, [inventoryIds]);

  if (loading) return <div className="widget-loading">Loading...</div>;
  if (error) return <div className="widget-error">{error}</div>;

  return (
    <div className="widget notes-summary">
      <h3 className="widget-title">Notes Summary</h3>
      <ul>
        {Object.entries(summary).map(([id, { total, unread }]) => (
          <li key={id}>
            <MessageSquare size={16} /> ID {id}: {total} notes ({unread} unread)
          </li>
        ))}
      </ul>
    </div>
  );
}